/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: sj
 * @LastEditTime: 2022-01-13 14:20:28
 */
import { Button, TableColumnType } from 'antd'
import React, { ReactElement } from 'react'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { addPartnerPlatformParams } from '../../services/partnerPlatform'
import { ThemeData } from '../../theme/ThemeContext'

export const columns = (
  onClick: (type: 'address' | 'manage' | 'toggle', tenant: addPartnerPlatformParams) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<addPartnerPlatformParams>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '合作平台名称',
      key: 'platformName',
      align: 'center',
      width: '12rem',
      dataIndex:'platformName'
    },
    {
      title: '联系人',
      key: 'contactName',
      align: 'center',
      width: '8rem',
      render: (_, t) => t.contactName || '-',
    },
    {
      title: '联系电话',
      key: 'contactPhone',
      align: 'center',
      width: '8rem',
      render: (_, t) => t.contactPhone || '-',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      width: '8rem',
      render: (_, t) => t.remark || '-',
    },
    {
      title: '状态',
      key: 'status',
      align: 'center',
      width: '10rem',
      render: function Status(_, t): ReactElement {
        const active = t.status === 0
        return (
          <StateSwitch value={active} onChange={() => onClick('toggle', t)} />
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Button type='primary' onClick={() => onClick('manage', t)}>
            编辑
          </Button>
        )
      },
    },
  ]
}
